import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import InternationalizedFormattedText from '../../../util/internationalized-formatted-text'
import { LANGUAGES_BY_BRAND } from '../../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import { storeSelectedLanguageActionCreator } from '../../../../redux/actions/actions'

const useStyles = makeStyles((theme) => ({
  langContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  langCode: {
    paddingRight: 12,
  },
  textColor: {
    color: theme.palette.headerLinks.text,
    float: 'right',
    marginBottom: 0,
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      color: theme.palette.headerLinks.hover,
    },
  },
  active: {
    color: theme.palette.headerLinks.hover,
    fontWeight: 'bold',
  },
}))

const LangBarBasicComponent = ({ onChangeLanguage }) => {
  const classes = useStyles()
  const locale = localStorage.getItem('locale')
  const brand = useSelector((state) => state.reducer.brand)
  const dispatch = useDispatch()

  return (
    <div className={classes.langContainer}>
      {LANGUAGES_BY_BRAND[brand.abbreviation].map((lang, index) => (
        <button
          id={lang.code}
          type='button'
          key={lang.code}
          className={`${classes.textColor}`}
          onClick={() => {
            onChangeLanguage(lang.code)
            dispatch(storeSelectedLanguageActionCreator(lang.code))
          }}
        >
          <InternationalizedFormattedText
            className={`${classes.langCode} ${locale === lang.code && classes.active}`}
            variant='subtitle1'
            id={lang.id}
          />
          {index < LANGUAGES_BY_BRAND[brand.abbreviation].length - 1 && (
            <span className={`langTextSeparator ${classes.textColor} `}>|</span>
          )}
        </button>
      ))}
    </div>
  )
}

LangBarBasicComponent.propTypes = {
  onChangeLanguage: PropTypes.func.isRequired,
}

export default LangBarBasicComponent
